import NoIndex from "@/components/no-index";
import VouchingSkeleton from "@/components/skeletons/vouching-skeleton";
import { useVouchSession } from "@/hooks/use-vouch-session";
import type { ProfileViewModel } from "@/lib/types";
import ExpiredVouchLink from "@/pages/expired-vouch-link";
import { Navigate, Outlet, useParams } from "react-router";

export default function VouchGuard() {
  const { vouchId } = useParams<{ vouchId: string }>();

  if (!vouchId) return <Navigate to="/" replace />;

  return (
    <>
      <NoIndex />
      <VouchGuardConsumer vouchId={vouchId} />
    </>
  );
}

function VouchGuardConsumer({ vouchId }: Readonly<{ vouchId: string }>) {
  const { data, isPending } = useVouchSession(vouchId);
  if (isPending) {
    return (
      <section className="vouch-gradient">
        <VouchingSkeleton />;
      </section>
    );
  }

  if (data?.ApiHttpResponse !== 200) {
    return (
      <section className="vouch-gradient">
        <ExpiredVouchLink />
      </section>
    );
  }

  return (
    <section className="vouch-gradient">
      <Outlet context={data.ApiResult satisfies ProfileViewModel} />
    </section>
  );
}
